import React, { useState, useRef, useEffect } from 'react';
import styles from './ThreeDotMenu.module.css';
import { BsThreeDotsVertical } from 'react-icons/bs';

const ThreeDotMenu = ({
  options,
  icon = <BsThreeDotsVertical size={20} />,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef();

  const handleToggle = () => setIsOpen((prev) => !prev);

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={styles.menuWrapper} ref={menuRef}>
      <div className={styles.iconButton} onClick={handleToggle}>
        {icon}
      </div>

      {isOpen && (
        <div className={styles.dropdown} onClick={() => setIsOpen(false)}>
          {options.map((option, index) => (
            <div
              key={index}
              className={styles.menuItem}
              onClick={option.onClick}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ThreeDotMenu;
